export default __webpack_public_path__ + "static/media/not-notifications.c0c89e85.png";